import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};

export const EscalatorIcon = ({ width = 60, height = 60, fill = 'currentColor', ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_6828_51801)">
                <g clipPath="url(#clip1_6828_51801)">
                    <path
                        d="M16.5413 60.1705H8.356C4.84667 60.1239 2 57.2399 2 53.7399C2 50.2399 4.884 47.3092 8.43067 47.3092C8.496 47.3092 11.0813 47.3092 12.08 47.3185L43.6733 19.4585C43.86 19.2999 44.0933 19.2065 44.336 19.2065H51.8587C55.3213 19.3932 57.9907 22.1932 57.9907 25.5719C57.9907 28.9505 55.2373 31.8999 51.7187 31.9932L47.136 32.0119L17.2227 59.8999C17.036 60.0772 16.7933 60.1705 16.532 60.1705H16.5413ZM8.43067 49.3252C5.99467 49.3252 4.016 51.3039 4.016 53.7399C4.016 56.1759 5.96667 58.1265 8.37467 58.1545H16.14L46.0627 30.2665C46.2493 30.0892 46.492 29.9959 46.744 29.9959L51.7 29.9772C54.0987 29.9212 55.984 27.9799 55.984 25.5719C55.984 23.1639 54.1547 21.3532 51.812 21.2225H44.7187L13.1253 49.0825C12.9387 49.2412 12.7147 49.3625 12.4533 49.3345C12.4533 49.3345 8.51467 49.3252 8.43067 49.3252Z"
                        fill={fill}
                    />
                    <path
                        d="M23.1211 18.6093C20.6104 18.6093 18.5664 16.5653 18.5664 14.0547C18.5664 11.544 20.6104 9.5 23.1211 9.5C25.6317 9.5 27.6757 11.544 27.6757 14.0547C27.6757 16.5653 25.6317 18.6093 23.1211 18.6093ZM23.1211 11.74C21.8424 11.74 20.8064 12.776 20.8064 14.0547C20.8064 15.3333 21.8424 16.3693 23.1211 16.3693C24.3997 16.3693 25.4357 15.3333 25.4357 14.0547C25.4357 12.776 24.3997 11.74 23.1211 11.74Z"
                        fill={fill}
                    />
                    <path
                        d="M18.8283 23.9011C18.8283 22.9958 19.5656 22.2585 20.471 22.2585H25.791C26.6963 22.2585 27.4336 22.9958 27.4336 23.9011V31.1345L29.4963 29.3145V23.9011C29.4963 21.8665 27.8256 20.1958 25.791 20.1958H20.471C18.4363 20.1958 16.7656 21.8665 16.7656 23.9011V40.5518L18.8283 38.7318V23.9011Z"
                        fill={fill}
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_6828_51801">
                    <rect width="60" height="60" fill={fill} />
                </clipPath>
                <clipPath id="clip1_6828_51801">
                    <rect width="56" height="50.6707" fill={fill} transform="translate(2 9.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};
